import { ShieldX, ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function AccessRestricted() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-full bg-status-expired-bg flex items-center justify-center mx-auto mb-6">
          <ShieldX className="w-8 h-8 text-status-expired" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Access Restricted
        </h1>
        
        <p className="text-gray-600 mb-6">
          You don't have permission to access this page. 
          Please contact an administrator if you believe this is an error.
        </p>
        
        <div className="flex gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          
          <Button
            onClick={() => navigate('/today')}
            className="flex items-center gap-2 bg-brand-teal hover:bg-brand-teal/90"
          >
            <Home className="w-4 h-4" />
            Schedule View
          </Button>
        </div>
      </div>
    </div>
  );
}
